import React from "react";
import "./Navbar.css";
import { useRef, useState, useEffect } from "react";
import Popup from "reactjs-popup";
import "./popup.css";
import { SERVER_URL } from "../config/config";

function Navbar(props) {
  const [currentYear, setCurrentYear] = useState("");
  const [yearIndex, setYearIndex] = useState(
    props.sessionObject.sessionVariables.financial_year_for_fetch
  );
  const [dateSelectorObj, setDateSelectorObj] = useState([]);
  const [show, setShow] = useState(false);

  const roleId = props.sessionObject.sessionVariables.role_id;

  const [backupTaskId, setBackupTaskId] = useState(null);
  const [backupLoading, setBackupLoading] = useState(false);
  const backupIntervalRef = useRef(null);
  const [backupPopupOpen, setBackupPopupOpen] = useState(false);
  const [backupPopupMsg, setBackupPopupMsg] = useState("");
  const [backupConfirmOpen, setBackupConfirmOpen] = useState(false);
  const isInitialYearSync = useRef(true);

  let navHide = localStorage.getItem("hide");

  // console.log({ currentYear, yearIndex});
  // console.log(props.sessionObject.sessionVariables);
  // console.log(props.sessionObject.sessionVariables.financial_year_for_fetch);

  const getLocalFlag = () => {
    try {
      return localStorage.getItem("local_flag") === "true";
    } catch (e) {
      return false;
    }
  };
  const setLocalFlag = () => {
    try {
      localStorage.setItem("local_flag", JSON.stringify(!isLocal));
    } catch (e) {
      console.log("Errorr asdf", e.message);
    }

    setIsLocal(!isLocal);
  };

  useEffect(() => {
    let selectorObj = [];
    const savedFinancialYear =
      props.sessionObject.sessionVariables.financial_year_for_fetch;

    const currDate = new Date();
    let currMonth = currDate.getMonth() + 1;
    let currYear =
      currDate.getFullYear().toString().substring(2) - (currMonth < 4);

    if (["bgtc", "ase"].includes(process.env.REACT_APP_CLIENT)) {
      let selectorObj = [];

      for (let i = 0; i < 2; i++) {
        let temp1 = currYear - i;
        let temp2 = temp1 + 1;

        let value = temp1 + "-" + temp2;
        let label = `01/04/20${temp1} - 31/03/20${temp2}`;

        selectorObj.push({ value, label });

        if (i === 0) {
          setCurrentYear(value);
        }
      }

      const hasSavedFinancialYear = selectorObj.some(
        (yearObj) => yearObj.value === savedFinancialYear
      );
      setYearIndex(hasSavedFinancialYear ? savedFinancialYear : selectorObj[0]?.value || "");
      setDateSelectorObj(selectorObj);
      return;
    }

    let yearRange = 4;
    let isCurrentYearSet = false;

    if (currYear == "21") {
      selectorObj.push({
        value: "22-23",
        label: "01/04/2022 - 31/03/2023",
      });
    }

    for (let i = 0; i < yearRange; i++) {
      let temp1 = currYear - i;
      let temp2 = temp1 + 1;
      let tempObj = {
        value: temp1 + "-" + temp2,
        label: "01/04/20" + temp1 + " - " + "31/03/20" + temp2,
      };

      if (!isCurrentYearSet) {
        isCurrentYearSet = true;
        setCurrentYear(temp1 + "-" + temp2);
      }

      selectorObj.push(tempObj);
    }
    const hasSavedFinancialYear = selectorObj.some(
      (yearObj) => yearObj.value === savedFinancialYear
    );
    setYearIndex(hasSavedFinancialYear ? savedFinancialYear : selectorObj[0]?.value || "");
    setDateSelectorObj(selectorObj);
    // console.log(branchInfo, yearIndex);
  }, [props.sessionObject.sessionVariables.financial_year_for_fetch]);

  useEffect(() => {
    if (!yearIndex) {
      return;
    }

    props.sessionObject.saveSessionVariableByObject({
      financial_year_for_fetch: yearIndex,
    });

    if (isInitialYearSync.current) {
      isInitialYearSync.current = false;
      return;
    }

    window.location.reload();
  }, [yearIndex]);

  const financialYearChanged = (e) => {
    const newYear = e.target.value;
    // console.log(e.target);
    setYearIndex(newYear);
  };

  const [isLocal, setIsLocal] = useState(getLocalFlag());

  const startBackup = async () => {
    try {
      setBackupLoading(true);

      const resp = await fetch(`${SERVER_URL}/backup/create-dump`, {
        method: "POST",
        headers: { Accept: "application/json" },
      });

      if (!resp.ok) throw new Error("Backup request failed");

      const data = await resp.json();

      if (!data.success || !data.task_id) {
        throw new Error("Invalid backup response");
      }

      setBackupTaskId(data.task_id);
      setBackupPopupMsg("Backup scheduled. Please wait...");
      setBackupPopupOpen(true);
    } catch (err) {
      console.error(err);
      setBackupPopupMsg("Failed to start backup.");
      setBackupPopupOpen(true);
      setBackupLoading(false);
    }
  };

  const checkBackupStatus = async (taskId) => {
    try {
      const resp = await fetch(`${SERVER_URL}/backup/backup-status/${taskId}`, {
        headers: { Accept: "application/json" },
      });

      if (!resp.ok) return;

      const data = await resp.json();

      if (data.status === "completed") {
        clearInterval(backupIntervalRef.current);
        backupIntervalRef.current = null;

        setBackupLoading(false);
        setBackupTaskId(null);

        setBackupPopupMsg("Backup completed successfully.");
        setBackupPopupOpen(true);

        window.location.href = `${SERVER_URL}/backup/download-backup/${taskId}`;
        return;
      }

      if (data.status === "failed") {
        clearInterval(backupIntervalRef.current);
        backupIntervalRef.current = null;

        setBackupLoading(false);
        setBackupTaskId(null);

        setBackupPopupMsg(data.message || "Backup failed.");
        setBackupPopupOpen(true);
      }
    } catch (err) {
      console.error("Backup status check failed", err);
    }
  };

  useEffect(() => {
    if (!backupTaskId) return;

    checkBackupStatus(backupTaskId);

    backupIntervalRef.current = setInterval(() => {
      checkBackupStatus(backupTaskId);
    }, 10000);

    return () => {
      if (backupIntervalRef.current) {
        clearInterval(backupIntervalRef.current);
      }
    };
  }, [backupTaskId]);

  return (
    <div>
      <Popup open={backupConfirmOpen} modal closeOnDocumentClick={false}>
        {(close) => (
          <div className="pop-up-container">
            <div className="pop-up-header">Confirm Backup</div>
            <div className="pop-up-content">
              Are you sure you want to take backup?
            </div>
            <div className="pop-up-actions">
              <button
                className="btn btn-primary"
                onClick={() => {
                  setBackupConfirmOpen(false);
                  startBackup();
                  close();
                }}
              >
                Yes
              </button>
              <button
                className="btn btn-primary"
                onClick={() => {
                  setBackupConfirmOpen(false);
                  close();
                }}
              >
                No
              </button>
            </div>
          </div>
        )}
      </Popup>

      <Popup open={backupPopupOpen} modal closeOnDocumentClick={false}>
        {(close) => (
          <div className="pop-up-container">
            <div className="pop-up-header">Backup Status</div>
            <div className="pop-up-content">{backupPopupMsg}</div>
            <div className="pop-up-actions">
              <button
                className="btn btn-primary"
                onClick={() => {
                  setBackupPopupOpen(false);
                  close();
                }}
              >
                Okay
              </button>
            </div>
          </div>
        )}
      </Popup>

      <nav className="navbar">
        <ul className="navbar-nav">{props.children}</ul>
        <div className="nav-additional">
          <div className="navbar-branch" style={{ whiteSpace: "nowrap" }}>
            F. Year:
            <select
              // className="navbar-branch"
              style={{
                backgroundColor: "#23293e",
                color: yearIndex == currentYear ? "lemonchiffon" : "red",
                fontFamily: "roboto",
              }}
              value={yearIndex}
              onChange={financialYearChanged}
            >
              {dateSelectorObj.map((date) => (
                <option
                  value={date["value"]}
                  key={date["value"]}
                  style={{
                    color: date.value == currentYear ? "lemonchiffon" : "red",
                  }}
                >
                  {date.label}
                </option>
              ))}
            </select>
          </div>
          <div className="navbar-branch">
            Branch:{" "}
            {JSON.parse(sessionStorage.getItem("branch_name"))[
              "branch_name"
            ].toUpperCase()}
          </div>

          <div className="navbar-branch">
            User:{" "}
            {JSON.parse(sessionStorage.getItem("user_name"))[
              "user_name"
            ].toUpperCase()}
          </div>

          {[1, 2].includes(roleId) && (
            <button
              className="log-out-container"
              onClick={() => setBackupConfirmOpen(true)}
              disabled={backupLoading}
              // style={{ marginRight: "10px" }}
            >
              {backupLoading ? "Processing..." : "Backup"}
            </button>
          )}

          <button className="log-out-container" onClick={props.handleLogout}>
            Logout
          </button>
        </div>
      </nav>

      {/* <nav className={show ? "navbar3" : "navbar2"}>
      <ul className="navbar-nav2">{props.children}</ul>
      <div className="nav-additional2">
        <div className="navbar-branch" style={{whiteSpace: "nowrap"}}>
          F. Year: 
          <select
                  className="navbar-branch"
                  style={{
                      backgroundColor: "#23293e", 
                      color: yearIndex == currentYear ?  "lemonchiffon" : "red",
                      fontFamily: "roboto",
                  }}
                  value={yearIndex}
                  onChange={financialYearChanged}
              >
                  {dateSelectorObj.map((date) => (
                  <option 
                      value={date["value"]} 
                      key={date["value"]}
                      style={{
                          color: date.value == currentYear ? "lemonchiffon": "red",
                      }}
                  >
                      {date.label}
                  </option>
              ))}
              </select>
        </div>
        <div className="navbar-branch">
        Branch: {JSON.parse(sessionStorage.getItem("branch_name"))["branch_name"].toUpperCase()}
        </div>
        <div className="navbar-branch">
        User: {JSON.parse(sessionStorage.getItem("user_name"))["user_name"].toUpperCase()}
        </div>
        <button className="log-out-container2" onClick={props.handleLogout}>
          Logout
        </button>
      </div>
      <div className="optional">
        <button onClick={()=> setShow(!show)}>MENU</button>
    </div>
    </nav> */}

      <div className={show ? "mobile-nav-height" : "mobile-nav"}>
        <div className="optional">
          <button onClick={() => setShow(!show)}>
            {show ? "CLOSE" : "MENU"}
          </button>
        </div>

        <nav className={show ? "navbar3 h-nav" : "navbar2"}>
          <ul className="navbar-nav2">{props.children}</ul>
          <div className="nav-additional2">
            <div className="navbar-branch" style={{ whiteSpace: "nowrap" }}>
              F. Year:
              <select
                className="navbar-branch"
                style={{
                  backgroundColor: "#23293e",
                  color: yearIndex == currentYear ? "lemonchiffon" : "red",
                  fontFamily: "roboto",
                }}
                value={yearIndex}
                onChange={financialYearChanged}
              >
                {dateSelectorObj.map((date) => (
                  <option
                    value={date["value"]}
                    key={date["value"]}
                    style={{
                      color: date.value == currentYear ? "lemonchiffon" : "red",
                    }}
                  >
                    {date.label}
                  </option>
                ))}
              </select>
            </div>
            <div className="navbar-branch">
              Branch:{" "}
              {JSON.parse(sessionStorage.getItem("branch_name"))[
                "branch_name"
              ].toUpperCase()}
            </div>
            <div className="navbar-branch">
              User:{" "}
              {JSON.parse(sessionStorage.getItem("user_name"))[
                "user_name"
              ].toUpperCase()}
            </div>

            {[1, 2].includes(roleId) && (
              <button
                className="log-out-container"
                onClick={() => setBackupConfirmOpen(true)}
                disabled={backupLoading}
                style={{ marginRight: "10px" }}
              >
                {backupLoading ? "Processing..." : "Backup"}
              </button>
            )}

            <button className="log-out-container2" onClick={props.handleLogout}>
              Logout
            </button>
          </div>
        </nav>
      </div>
    </div>
  );
}

export default Navbar;
